import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './OperationDetailsContent.styles';
import {
  getOperationRows,
  getOperationTitle,
} from './OperationDetailsContent.helpers';
import { DownloadIcon, SmallChevronIcon } from '@/components/UI/Icons/Icons';
import { formatNumber } from '@/utils/helpers';
import { Operation } from '@/features/Profile/sections/Transactions/Transactions.types';

interface OperationDetailsContentProps {
  operation: Operation;
  onClose: () => void;
}

export const OperationDetailsContent = ({
  operation,
  onClose,
}: OperationDetailsContentProps) => {
  const { t } = useTranslation();

  const { price, title: adTitle, image, path = '' } = operation.ad || {};
  const title = getOperationTitle(operation, t);
  const rows = getOperationRows(operation, t);
  const totalIndex = rows.findIndex(row => row.isTotal);

  return (
    <S.Container>
      <S.Header>
        <S.Title>{title}</S.Title>
        <S.CloseButton role="button" aria-label="Close" onClick={onClose} />
      </S.Header>

      {operation.ad ? (
        <S.AdCard href={path} onClick={onClose}>
          <S.AdImage
            src={image || '/images/profile-square.svg'}
            alt={adTitle}
          />
          <S.AdInfo>
            <S.AdPrice>
              {price ? `${formatNumber(price, 2)} AZN` : ''}
            </S.AdPrice>
            <S.AdTitle>{adTitle}</S.AdTitle>
          </S.AdInfo>
          <S.AdChevron>
            <SmallChevronIcon width={6} height={12} />
          </S.AdChevron>
        </S.AdCard>
      ) : null}

      <S.Details>
        {rows.map(({ label, value, isTotal, href }, index) => {
          const LabelComponent = isTotal ? S.TotalLabel : S.Label;
          const ValueComponent = isTotal ? S.TotalValue : S.Value;

          return (
            <React.Fragment key={label}>
              {index === totalIndex && index > 0 ? <S.Divider /> : null}
              <S.Row>
                <LabelComponent>{label}</LabelComponent>
                {href ? (
                  <S.ValueWithAction>
                    <S.InvoiceDownload
                    // href={href}
                    >
                      <DownloadIcon width={20} height={20} />
                    </S.InvoiceDownload>
                    <ValueComponent>{value}</ValueComponent>
                  </S.ValueWithAction>
                ) : (
                  <ValueComponent>{value}</ValueComponent>
                )}
              </S.Row>
            </React.Fragment>
          );
        })}
      </S.Details>
    </S.Container>
  );
};
